"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshTokenRequestSchema = exports.JWTPayloadSchema = exports.AuthResponseSchema = exports.SocialLoginRequestSchema = exports.AuthProviderSchema = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
// Authentication Provider
exports.AuthProviderSchema = zod_1.z.enum(['google', 'apple']);
// Social Login Request
exports.SocialLoginRequestSchema = zod_1.z.object({
    provider: exports.AuthProviderSchema,
    token: zod_1.z.string(),
    deviceInfo: zod_1.z.object({
        platform: zod_1.z.enum(['web', 'ios', 'android', 'extension']),
        userAgent: zod_1.z.string().optional(),
        deviceId: zod_1.z.string().optional(),
    }).optional(),
});
// Authentication Response
exports.AuthResponseSchema = zod_1.z.object({
    accessToken: zod_1.z.string(),
    refreshToken: zod_1.z.string(),
    expiresIn: zod_1.z.number(),
    user: zod_1.z.object({
        id: common_1.UUIDSchema,
        email: zod_1.z.string().email(),
        provider: exports.AuthProviderSchema,
        subscriptionTier: zod_1.z.enum(['trial', 'basic', 'premium', 'professional']),
        trialChecksUsed: zod_1.z.number(),
        communityLevel: zod_1.z.string(),
        reputationScore: zod_1.z.number(),
    }),
});
// JWT Payload
exports.JWTPayloadSchema = zod_1.z.object({
    sub: common_1.UUIDSchema, // User ID
    email: zod_1.z.string().email(),
    provider: exports.AuthProviderSchema,
    tier: zod_1.z.enum(['trial', 'basic', 'premium', 'professional']),
    iat: zod_1.z.number(),
    exp: zod_1.z.number(),
});
// Refresh Token Request
exports.RefreshTokenRequestSchema = zod_1.z.object({
    refreshToken: zod_1.z.string(),
});
//# sourceMappingURL=auth.js.map